//Encriptacion en base a IDM
const CryptoJS = require("crypto-js"); 
export default function crp (pss){
    const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRP);
    const message = pss;
    const iv =  CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRP);
    const encrypted = CryptoJS.AES.encrypt(message, key, {
            keySize:16,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );
    return encrypted.toString();
}